import type {CreateExtArgs} from '@wix/document-manager-core'
import type {CompRef, BreakpointsMap, BreakpointRange, DependenciesManager} from '@wix/document-services-types'
import type {DependencyMatcher} from './types'
import type {VariantsExtensionAPI} from '../../../../variants/variants'
import _ from 'lodash'
import type {DataModelExtensionAPI} from '../../../../dataModel/dataModel'
import {DATA_TYPES} from '../../../../../constants/constants'

const getPageBreakpoints = (
    {pointers, extensionAPI}: CreateExtArgs,
    componentToReplace: CompRef
): BreakpointRange[] => {
    const pagePointer = pointers.structure.getPageOfComponent(componentToReplace)
    if (!pagePointer) {
        return []
    }

    const {dataModel} = extensionAPI as DataModelExtensionAPI
    return dataModel.components.getItemByQuery(pagePointer, 'breakpointVariantsQuery')?.values ?? []
}

const getBreakpointDependencies = (dependencies: DependenciesManager): BreakpointsMap => {
    const variantRefs = dependencies.references.getReferences()[DATA_TYPES.variants] ?? {}
    const breakpointRefs = _.pickBy(variantRefs, ref => ref.type === 'BreakpointRange')

    return _.mapValues(breakpointRefs, ref => _.pick(ref.info, ['min', 'max', 'canvasSize']))
}

export const breakpointsMatcher: DependencyMatcher = {
    match(extensionContext: CreateExtArgs, dependencies: DependenciesManager, componentToReplace: CompRef): void {
        const breakpointsMap: BreakpointsMap = getBreakpointDependencies(dependencies)
        if (_.isEmpty(breakpointsMap)) {
            return
        }

        const pageBreakpoints: BreakpointRange[] = getPageBreakpoints(extensionContext, componentToReplace)
        const {variants} = extensionContext.extensionAPI as VariantsExtensionAPI
        const {matches} = variants.matchBreakpoints(breakpointsMap, pageBreakpoints)

        for (const [sourceId, targetId] of Object.entries(matches)) {
            dependencies.references.setTarget(sourceId, DATA_TYPES.variants, targetId)
        }
    }
}
